import { useIsMobile } from '../use-is-mobile';

/* This is key to making the items fill the alloted space within the mobile breakpoint */
const styleGridItemChild = {
    width: 'max-content',
    maxWidth: '100%',
};

export const useGlobalGridItemStyles = () => {
    const isMobile = useIsMobile('lg');
    return isMobile ? styleGridItemChild : null;
};
